<script>
import AppModal from '@/components/AppModal.vue'
import VisualizarCadastro from './VisualizarCadastro.vue'

export default {
  components: {
    AppModal,
    VisualizarCadastro
  },

  props: {
    protocolo: {
      type: String
    },
    cadastroContainerCustomClasses: {
      type: [String, Array],
      required: false
    }
  },

  methods: {
    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>

<template>
  <app-modal
    titulo="Visualizar processo"
    :closeOutside="true"
    @closeModal="closeModal"
    :hasFooter="false"
    :width="1000"
  >
    <template slot="body">
      <VisualizarCadastro :protocolo="protocolo" :cadastroContainerCustomClasses="cadastroContainerCustomClasses"/>
    </template>
  </app-modal>
</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/AppModalVisualizarCadastro.vue